import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { getDynamicParamConditionOptions, getExternalParamResolvers, smartDocParamCondition_LabelMap, smartDocParamResolverLabelMap, smartDocParamType_External } from '@app/advisor-content-shared';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { Filter } from '@nu-art/ts-common';
const viewMode_View = 'view';
const viewMode_Edit = 'edit';
export class Editor_SmartDocParam_Dynamic extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        state.params = nextProps.params;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    getParentKeyAdapter = () => {
        const options = this.state.params.filter(param => param.type === smartDocParamType_External).map(param => param.key);
        return SimpleListAdapter(options, item => _jsx(_Fragment, { children: item.item }));
    };
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [this.renderParentKey(), this.renderResolver(), this.render_Condition()] });
    }
    renderParentKey = () => {
        const param = this.state.editable;
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__value', children: "For parent key" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: param.item.externalKey ?? 'N/A' }) }) },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                const adapter = this.getParentKeyAdapter();
                                const filter = new Filter(i => [i]);
                                return _jsx(TS_DropDown, { adapter: adapter, selected: param.item.externalKey, onSelected: externalKey => {
                                        param.updateObj({ externalKey: externalKey });
                                    }, noOptionsRenderer: this.renderParentKey_NoOptions, filter: filter, onNoMatchingSelectionForString: val => this.props.createNewExternalParam(param.item.key, val) });
                            }
                        }
                    ] })] });
    };
    renderParentKey_NoOptions = () => {
        return _jsx(_Fragment, { children: "No matching param keys. To add a new external param, write out the param key and press \"Enter\"" });
    };
    renderResolver = () => {
        const param = this.state.editable;
        const parentParam = this.state.params.find(_param => _param.key === param.item.externalKey && _param.type === smartDocParamType_External);
        if (!parentParam && param.item.externalKey) {
            this.logError(`externalKey ${param.item.externalKey} does not point to an actual param`);
            return;
        }
        const resolverOptions = getExternalParamResolvers(parentParam);
        if (!resolverOptions.length)
            return;
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__value', children: "With resolver" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: smartDocParamResolverLabelMap[param.item.resolver] ?? 'N/A' }) })
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                const adapter = SimpleListAdapter(resolverOptions, node => _jsx(_Fragment, { children: smartDocParamResolverLabelMap[node.item] }));
                                return _jsx(TS_DropDown, { adapter: adapter, selected: param.item.resolver, onSelected: resolver => param.updateObj({ resolver: resolver }) });
                            }
                        }
                    ] })] });
    };
    render_Condition = () => {
        const param = this.state.editable;
        const parentParam = this.state.params.find(_param => _param.type === smartDocParamType_External && _param.key === param.item.externalKey);
        if (!parentParam) {
            if (param.item.externalKey)
                this.logError(`externalKey ${param.item.externalKey} does not point to an actual param`);
            return;
        }
        const conditionOptions = getDynamicParamConditionOptions(parentParam);
        if (!conditionOptions.length)
            return;
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row', children: [_jsx("div", { className: 'editor__smart-doc-param__value', children: "With Condition" }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        {
                            key: viewMode_View,
                            renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: smartDocParamCondition_LabelMap[param.item.condition] ?? 'N/A' }) })
                        },
                        {
                            key: viewMode_Edit,
                            renderer: () => {
                                const adapter = SimpleListAdapter(conditionOptions, node => _jsx(_Fragment, { children: smartDocParamCondition_LabelMap[node.item] }));
                                return _jsx(TS_DropDown, { adapter: adapter, selected: param.item.condition, onSelected: condition => param.updateObj({ condition: condition }) });
                            }
                        }
                    ] })] });
    };
}
//# sourceMappingURL=Editor_SmartDocParam_Dynamic.js.map